import React,{useEffect,useState} from 'react';
import {unsubscribeMarketing} from '../api/marketingApi';
export default function MarketingUnsubscribe() {
  const [token]=useState(()=>window.location.hash.slice(1));
  const [busy,setBusy]=useState(false),[done,setDone]=useState(false),[error,setError]=useState('');
  useEffect(()=>{window.history.replaceState(window.history.state,'',window.location.pathname);},[]);
  async function confirm() {
    setBusy(true);setError('');
    try {await unsubscribeMarketing(token);setDone(true);}
    catch {setError('Collegamento non valido, scaduto o servizio non disponibile. Puoi gestire le preferenze dal profilo.');}
    finally {setBusy(false);}
  }
  return <main className="prf-wrap"><section className="prf-section"><div className="prf-body">
    <h1>Disiscrizione dalle email commerciali</h1>
    {done?<p role="status">Marketing email disattivato. Le comunicazioni necessarie al servizio restano attive.</p>:<>
      <p>Conferma per revocare il marketing via email. Non occorre accedere al tuo account.</p>
      <button className="prf-btn" disabled={busy||!/^[a-f0-9]{64}$/.test(token)} onClick={confirm}>Conferma disiscrizione</button>
    </>}
    {error&&<p role="alert">{error}</p>}
  </div></section></main>;
}
